import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ALL_ROUTES } from '../../../../routes/dashboard/overview/AllPathNames';
import { RavenTab } from '@ravenpay/raven-bank-ui';
import { colorToRgba } from '../../../../utils/helper/Helper';

interface myComponentProps {
	activeTabIndex?: string;
	setActiveTabIndex?: (param?: any) => void;
}

const TerminalTabLink = ({
	activeTabIndex,
	setActiveTabIndex,
}: myComponentProps) => {
	const navigate = useNavigate();

	const listToUse = [
		{
			label: 'Physical Terminal',
			active: activeTabIndex === ALL_ROUTES?.PHYSICAL_TERMINALS,
			value: ALL_ROUTES?.PHYSICAL_TERMINALS,
			onClick: () =>
				setActiveTabIndex && setActiveTabIndex(ALL_ROUTES?.PHYSICAL_TERMINALS),
		},
		{
			label: 'Virtual Terminal',
			active: activeTabIndex === ALL_ROUTES?.VIRTUAL_TERMINALS,
			value: ALL_ROUTES?.VIRTUAL_TERMINALS,
			onClick: () =>
				setActiveTabIndex && setActiveTabIndex(ALL_ROUTES?.VIRTUAL_TERMINALS),
		},
	];

	return (
		<>
			<RavenTab
				activeBgColor={colorToRgba('var(--primary-base-color)', 0.1)}
				activeColor="var(--primary-base-color)"
				list={listToUse}
				style={{ marginTop: '0rem' }}
			/>
		</>
	);
};

export default TerminalTabLink;
